import React from "react";
// Common Components
import OrderBookTable from "../OrderBookTable";
// Local Components
// Hooks
import useRequest from "src/Hooks/useRequest";
// Requests
import { getOptionsOrderbook } from "src/Requests/iMEMarketWatch";
// Types
import type {
  ISelectedTableInfo,
  IOrderbooksBody,
} from "src/Interfaces/iMEMarketWatch";

interface IProps {
  selectedTableInfo: ISelectedTableInfo | null;
}

const Orderbook: React.FC<IProps> = ({ selectedTableInfo }) => {
  const orderBookRequest = useRequest(
    () => getOptionsOrderbook(selectedTableInfo?.contractCode || ""),

    () => {},
  );

  React.useEffect(() => {
    if (!selectedTableInfo) return;
    orderBookRequest.fetchData();
    const interval = setInterval(() => {
      orderBookRequest.fetchData();
    }, 4000);

    return () => clearInterval(interval);
  }, [selectedTableInfo]);

  const getOrderbookValues = (
    values?: IOrderbooksBody[],
  ): IOrderbooksBody[] => {
    if (!values || !values.length) return new Array(1).fill(null as any);

    if (values.length < 1) {
      const res: IOrderbooksBody[] = [...values];
      for (let index = 0; index < 1 - values.length; index++) {
        res.push(null as any);
      }
      return res;
    }
    return values;
  };

  return (
    <div className="flex flex-row justify-start items-end pt-5">
      {getOrderbookValues(orderBookRequest?.response?.orderBooks)?.map(
        (resp: any) => (
          <div className="mx-0.5">
            <OrderBookTable tableInfo={resp?.fullOrderBook} logo="ime" />
          </div>
        ),
      )}
    </div>
  );
};

export default Orderbook;
